import { render, staticRenderFns } from "./ArrowUpIcon.vue?vue&type=template&id=20642880"
import script from "./ArrowUpIcon.vue?vue&type=script&lang=ts"
export * from "./ArrowUpIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports